import { Controller } from "@hotwired/stimulus"

import ElmCarousel from "@/components/elm_carousel"
import { loadBackgroundImages } from "@/helpers/image_loader"

declare global {
  interface Window {
    roomCarouselFlags: { [key: number]: string }
  }
}

export default class extends Controller {
  static targets = ["elmNode"]
  declare readonly elmNodeTarget: HTMLDivElement

  static values = { roomFlags: Object, roomId: Number }
  declare readonly roomFlagsValue: { [key: number]: string }
  declare readonly roomIdValue: number

  initialize(): void {
    this.loadImages = this.loadImages.bind(this)
  }

  elmNodeTargetConnected(): void {
    new ElmCarousel({
      node: this.elmNodeTarget,
      flags: this.roomFlagsValue,
      ports: {
        carouselActivated: this.loadImages.bind(this),
        ready: this.loadImages.bind(this)
      }
    })
  }

  private loadImages(): void {
    loadBackgroundImages(this.element.querySelectorAll("[data-img]"))
  }
}
